import React from 'react';
import { ArtDecoFrame } from './ArtDecoFrame';
import { SuitDivider } from './SuitDivider';
import { SectionReveal } from './SectionReveal';
export function Registry() {
  return <section className="relative bg-deep-green py-24 md:py-32" data-id="element-167">
      <div className="max-w-6xl mx-auto px-6" data-id="element-168">
        <SectionReveal data-id="element-169">
          {/* Section header */}
          <div className="text-center mb-16" data-id="element-170">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-goldenrod uppercase tracking-[0.3em] mb-4" data-id="element-171">
              The Registry
            </h2>
            <p className="font-body text-goldenrod/70 italic text-lg tracking-wide" data-id="element-172">
              Establishment &amp; Correspondence
            </p>
            <SuitDivider className="mt-8 max-w-md mx-auto" data-id="element-173" />
          </div>

          {/* Registry content */}
          <div className="max-w-2xl mx-auto" data-id="element-174">
            <ArtDecoFrame variant="full" data-id="element-175">
              <div className="text-center space-y-8" data-id="element-176">
                {/* Mission */}
                <p className="font-body text-ivory/90 text-lg md:text-xl leading-relaxed italic" data-id="element-177">
                  "To advance the science of strategic decision-making through
                  artificial intelligence, building systems that master the
                  deepest complexities of imperfect-information games."
                </p>

                <div className="text-goldenrod/40 tracking-[0.8em] text-sm select-none" aria-hidden="true" data-id="element-178">
                  ♠ ♦ ♣ ♥
                </div>

                {/* Company details */}
                <div className="space-y-4" data-id="element-179">
                  <div data-id="element-180">
                    <p className="font-display text-goldenrod uppercase tracking-[0.2em] text-sm mb-1" data-id="element-181">
                      Registered Entity
                    </p>
                    <p className="font-body text-ivory/90 text-lg" data-id="element-182">
                      Strategame Ltd.
                    </p>
                  </div>

                  <div data-id="element-183">
                    <p className="font-display text-goldenrod uppercase tracking-[0.2em] text-sm mb-1" data-id="element-184">
                      Domicile
                    </p>
                    <p className="font-body text-ivory/90 text-lg" data-id="element-185">
                      Limassol, Cyprus
                    </p>
                  </div>

                  <div data-id="element-186">
                    <p className="font-display text-goldenrod uppercase tracking-[0.2em] text-sm mb-1" data-id="element-187">
                      Correspondence
                    </p>
                    <a href="mailto:inquiries@strategame.ai" className="font-body text-goldenrod/90 text-lg hover:text-goldenrod transition-colors duration-300 underline underline-offset-4 decoration-goldenrod/30 hover:decoration-goldenrod/60" data-id="element-188">
                      inquiries@strategame.ai
                    </a>
                  </div>

                  <div data-id="element-189">
                    <p className="font-display text-goldenrod uppercase tracking-[0.2em] text-sm mb-1" data-id="element-190">
                      Operating Currency
                    </p>
                    <p className="font-body text-ivory/90 text-lg" data-id="element-191">EUR</p>
                  </div>
                </div>
              </div>
            </ArtDecoFrame>
          </div>
        </SectionReveal>
      </div>
    </section>;
}